import script from "./TableStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./TableStylePanel.vue?vue&type=style&index=0&id=4fc8e21d&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc8e21d"]])

export default __exports__